/**
 * 댓글에 스티커처럼 붙이는 반응 이모지 — 고정 세트(자유 입력 없음, 서버가 검증).
 * 누가 눌렀는지는 비공개(카운트만 노출, 절대 규칙 9의 정신) — 내 반응 여부만 안다.
 */
export const COMMENT_REACTIONS = ['🍅', '👍', '❤️', '😂', '😮', '🙏'];
export const COMMENT_LIMITS = {
    bodyMax: 2000,
};
//# sourceMappingURL=comment.js.map